import { globalComponents } from 'src/types/globalTypes';
import DetailPage from '../DetailPage';
import { useLocation, useNavigate } from 'react-router-dom';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import useRequest from 'src/api/useRequest';
import React, { useCallback, useState } from 'react';
import QueryString from 'qs';
import ResultLoading from 'src/components/ui-kit/ResultLoading';
import { tmarkRightsServiceProvider } from 'src/api/service/tmarkRightsService';
import { IResTmarkRightsDetail } from 'src/types/api/trademarkRightsApiTypes';
import { getTmarkClass } from 'src/components/layout/tag/TmarkClassTag';
import NotFoundPage from 'src/components/layout/notFound/NotFoundPage';

import { WrapperDetailInfo, NoContent } from 'src/components/contents/detail/DetailPage';
import InfoTmarkRightBase from './infoComponents/InfoTmarkRightBase';
import InfoTmarkRights from './infoComponents/InfoTmarkRights';
import InfoTmarkChange from './infoComponents/InfoTmarkChange';
import InfoTmarkDivide from './infoComponents/InfoTmarkDivide';
import InfoTmarkPriority from './infoComponents/InfoTmarkPriority';
import InfoQrCode from '../InfoQrCode';
import InfoGoods from './infoComponents/InfoGoods';
import { IReqQRCode, QrCodeUuidCheck } from 'src/types/api/qrCodeTypes';
import { useModalStore } from 'src/hooks/useStore';
import UuidAlertModal from '../UuidAlertModal';

// 自訂 react router state 傳遞過來的參數格式
interface CustomizedState {
  examNo: string;
  tmarkClass: string;
}

const tmarkRightsService = tmarkRightsServiceProvider();

/**
 * 商標案件明細
 */
const TmarkDetail: React.FC = () => {
  const navigate = useNavigate();
  const setActiveModal = useModalStore((state) => state.setActiveModal);
  const oldUser = useModalStore((state) => state.isOldUser);
  // 表格資訊
  const component = globalComponents.T;
  const colorType = component.color;
  const angleColor = colorType.fifth;
  const NO_CONTENT = <NoContent>(無)</NoContent>; //該欄位無資料顯示項目

  // 控制各區塊收合
  const [isShowTmarkRightBase, setIsShowTmarkRightBase] = useState<boolean>(true);
  const [isShowGoods, setIsShowGoods] = useState<boolean>(false);
  const [isShowTmarkRights, setIsShowTmarkRights] = useState<boolean>(false);
  const [isShowTmarkPriority, setIsShowTmarkPriority] = useState<boolean>(false);
  const [isShowTmarkDivide, setIsShowTmarkDivide] = useState<boolean>(false);
  const [isShowTmarkChange, setIsShowTmarkChange] = useState<boolean>(false);
  const [isShowQRcode, setIsShowQRcode] = useState<boolean>(false);

  // 取得案件資料
  const location = useLocation();
  let state = null;
  let examNo = '';
  let tmarkClass = '';

  // QR code資料
  const { search } = useLocation();
  const params = QueryString.parse(search, { ignoreQueryPrefix: true });
  const [qrCode] = useState<IReqQRCode>({
    qrCode: params.QRcode?.toString() || params.QRCode?.toString() || params.QRCODE?.toString(),
    dataNo: params.DataNo?.toString(),
    dataClass: params.DataCls?.toString(),
    uuid: params.UUID?.toString(),
  });

  if (location.state !== null) {
    state = location.state as CustomizedState;
    examNo = state.examNo;
    tmarkClass = state.tmarkClass;
  }

  const [isLoading, , res] = useRequest<IResTmarkRightsDetail>(
    useCallback(() => {
      return tmarkRightsService.getTmarkRightsByExamNo(examNo, tmarkClass, qrCode);
    }, [examNo, tmarkClass, qrCode]),
  );

  const desktopForm = res ? (
    <WrapperDetailInfo>
      <DropdownInfo
        title={`商標種類：${getTmarkClass(res.tmarkRight.tmarkClass)}`}
        color={angleColor}
      />
      <InfoTmarkRightBase
        data={res.tmarkRight}
        certPdfChkDetail={res.certPdfChkDetail}
        isShow={isShowTmarkRightBase}
        setIsShow={setIsShowTmarkRightBase}
        colorType={colorType}
        noContent={NO_CONTENT}
      />
      {res.tmarkRight.goodsClasses.length !== 0 && (
        <InfoGoods
          data={res.tmarkRight.goodsClasses}
          isShow={isShowGoods}
          setIsShow={setIsShowGoods}
          colorType={colorType}
          noContent={NO_CONTENT}
        />
      )}
      <InfoTmarkRights
        data={res.tmarkRight}
        isShow={isShowTmarkRights}
        setIsShow={setIsShowTmarkRights}
        colorType={colorType}
        noContent={NO_CONTENT}
      />
      {res.tmarkChange && (
        <InfoTmarkChange
          data={res.tmarkChange}
          isShow={isShowTmarkChange}
          setIsShow={setIsShowTmarkChange}
          colorType={colorType}
          noContent={NO_CONTENT}
        />
      )}
      {res.tmarkDivide && (
        <InfoTmarkDivide
          data={res.tmarkDivide}
          isShow={isShowTmarkDivide}
          setIsShow={setIsShowTmarkDivide}
          colorType={colorType}
          noContent={NO_CONTENT}
        />
      )}
      {res.tmarkPriorityContent && (
        <InfoTmarkPriority
          data={res.tmarkPriorityContent}
          isShow={isShowTmarkPriority}
          setIsShow={setIsShowTmarkPriority}
          colorType={colorType}
          noContent={NO_CONTENT}
        />
      )}
      <InfoQrCode
        data={res.qrCodeImage}
        isShow={isShowQRcode}
        setIsShow={setIsShowQRcode}
        colorType={colorType}
        noContent={NO_CONTENT}
      />
    </WrapperDetailInfo>
  ) : (
    <NotFoundPage />
  );

  return (
    <>
      <DetailPage
        title={component.title}
        bannerBgImg={component.bgImgResultBanner}
        image={component.hoverImage}
        imgDot={component.bgImgDot}
        bgColor={component.color}
        onClikcReturnPage={() => navigate(-1)}
      >
        {isLoading ? <ResultLoading color={component.color.third} /> : desktopForm}
      </DetailPage>
      {!isLoading &&
        res?.qrCodeApiResultCode === QrCodeUuidCheck.U03 &&
        !oldUser &&
        setActiveModal(<UuidAlertModal />)}
    </>
  );
};

export default TmarkDetail;
